import React, {useState} from 'react';
import Navbar from 'react-bootstrap/Navbar';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {Container, Offcanvas, Nav, NavDropdown, Form, FormControl, Button }from "react-bootstrap";

import logo from "../../static/assets/GPRlogoBlack.png";


const NavBarMenu = () => {
  const options = [
    {
      name: <FontAwesomeIcon icon="fa-solid fa-ellipsis" />,
      scroll: true,
      backdrop: true,
    }
  ];
  
  function ClickMenu({ name, ...props }) {
    const [show, setShow] = useState(false);
  
    const handleClose = () => setShow(false);
    const toggleShow = () => setShow((s) => !s);
  
    return (
      <div>
        <Button variant="primary" onClick={toggleShow} className="me-2">
          {name}
        </Button>
        <Offcanvas show={show} onHide={handleClose} {...props}>
          <Offcanvas.Header closeButton>
            <Offcanvas.Title>Our Services</Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <ul className='onClick-menu-list'>
              <li><a>Concrete</a> </li>
              <li> <a>Shortcrete</a></li>
              <li> <a>Demolition</a></li>
            </ul>
            <div className='onClick-menu-list-nav-links'>
              <div className='links'>
                <a href="/">Home</a>
                <a href="/about">About</a>
                <a href="/contact">Contact</a>
              </div>
            </div>
            <div className='onClick-menu-logo'>
              <img src={logo} />
            </div>
          </Offcanvas.Body>
        </Offcanvas>
      </div>
    );
  }
  
  function Menu() {
    return (
      <div>
        {options.map((props, idx) => (
          <ClickMenu key={idx} {...props} />
        ))}
      </div>
    );
  }
  
  return (
    <div>
      <Menu />
    </div>
    );
}

export default NavBarMenu;